"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CameraGridSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var CameraGridSVG = function CameraGridSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("rect", {
    x: "11.98",
    y: "12.01",
    width: "7.98",
    height: "7.98"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "2",
    y: "12.01",
    width: "7.98",
    height: "7.98"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "11.98",
    y: "21.99",
    width: "7.98",
    height: "8.01"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M28,2H22v8h8V4A2,2,0,0,0,28,2Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M2,28a2,2,0,0,0,2,2h6V22H2Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M22,30h6a2,2,0,0,0,2-2V22H22Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M2,4v6h8V2H4A2,2,0,0,0,2,4Z"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "11.98",
    y: "2",
    width: "7.98",
    height: "8.01"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "21.96",
    y: "12.01",
    width: "8.04",
    height: "7.98"
  }));
};
exports.CameraGridSVG = CameraGridSVG;
CameraGridSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(CameraGridSVG);
exports.default = _default;